<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
  font-weight: 400;
}

body {
  margin: 0px;
  padding: 0px;
}

html {
  font-size: 16px;
  box-sizing: content-box;
}

/* 替换的富文本样式 */
.content-img {
  /* width: 100% !important; */
  height: auto !important;
}

.content-video {
  /* width: 100% !important; */
  height: auto !important;
  max-width: 100% !important;
}

@media screen and (max-width: 700px) {
  .content-img {
    max-width: 100% !important;
  }
}

/* 单行文本溢出 */
.text-overflow-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 多行文本溢出 */
.text-overflow-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 多行文本溢出 */
.text-overflow-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* 多行文本溢出 */
.text-overflow-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}

/* 多行文本溢出 */
.text-overflow-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
}

/* 水平居中 */
.center {
  display: flex;
  justify-content: center;
}

/* 垂直居中 */
.center-v {
  display: flex;
  align-items: center;
}

.el-pager li.active {
  color: #B20000;
}

.el-pager li:hover {
  color: #B20000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue